import {NavLink} from 'react-router-dom';
import {useEffect, useRef, useState} from 'react';
import useIsMobile from '../hook/useIsMobile';
import {motion,useAnimation} from 'framer-motion';

export default function Header() {

  const [isShowHeader, setIsShowHeader] = useState(true);
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const isMobile = useIsMobile();

  const isOpenMenuRef = useRef(false);

  const [style, setStyle] = useState('colorful');


  const clickMenu = () => {
    if (!isOpenMenu) {
      setIsShowHeader(true);
    }
    isOpenMenuRef.current = !isOpenMenuRef.current;
    setIsOpenMenu(prev => !prev);
  }

  const handleWheel = (e) => {
    const curY = e.deltaY;

    if (isOpenMenuRef.current) {
      setIsShowHeader(true);
    }
    else if (curY < 0 || window.scrollY === 0) {
      setIsShowHeader(true);
    }
    else {
      setIsShowHeader(false);
    }
  };

  const handleScroll = () => {
    const sections = document.querySelectorAll('[data-bg-type]');


    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const headerHeight = 100; // 헤더 높이

      // 헤더 영역과 섹션이 겹치는지 확인
      if (rect.top <= headerHeight && rect.bottom >= 0) {
        setStyle(section.getAttribute('data-bg-type'));
      }
    });
  }

  useEffect(() => {
    window.addEventListener('wheel', handleWheel, { passive: true });
    window.addEventListener('scroll', handleScroll, { passive: true });

    let style = null;
    const sections = document.querySelectorAll('[data-bg-type]');
    sections.forEach(section => {
      if (section.getAttribute('data-bg-type') && style === null) {
        style = section.getAttribute('data-bg-type');
      }
    });
    setStyle(style);

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  return (
    <header className={`fixed top-0 left-0 w-full  z-[100]`}>
      <motion.div
        className={`flex justify-between px-[5%] py-[5%] lg:h-[90px] lg:px-[9%] lg:py-0 transition-transform duration-300 ease-in-out 
        ${isShowHeader ? 'translate-y-0' : '-translate-y-full'} 
        ${isOpenMenu ? 'border-b-[1px] border-b-border-300 bg-white' : style === 'colorful' ? 'border-b-[1px] border-white' : `bg-white ${isMobile ? 'border-b-[1px] border-b-border-300' : ''}`}
      `}

      >
        <NavLink to="/" className='flex items-center'>
          <img
            src={isOpenMenu ? '/logo.png' : style === 'colorful' ?  '/logo_white.png' : '/logo.png'}
            alt="모듈링크"
            className="w-[102px] lg:w-[143px]"
          />
        </NavLink>

        <div className={`lg:flex hidden items-center gap-x-[80px] ${style === 'colorful' ? 'text-white' : 'text-label-200'} text-heading3`}>
          <NavLink className='hover:opacity-60' to="/about">회사소개</NavLink>
          <NavLink className='hover:opacity-60' to="/business">사업내용</NavLink>
          <NavLink className='hover:opacity-60' to='/core'>핵심역량</NavLink>
          <NavLink className='hover:opacity-60' to='/news'>뉴스</NavLink>
          <NavLink className='hover:opacity-60' to='/contact'>문의하기</NavLink>
        </div>

        <div className="lg:hidden flex items-center">
          <svg width="24" height="24"
               viewBox="0 0 24 24"
               fill="none"
               cursor="pointer"
               xmlns="http://www.w3.org/2000/svg"
               onClick={clickMenu}
          >
            <path d="M4 18H20M4 6H20H4ZM4 12H20H4Z" stroke={isOpenMenu ? "#393939" : style === 'colorful' ? '#FFF' : "#393939"} strokeWidth="2" strokeLinecap="round"
                  strokeLinejoin="round"/>
          </svg>
        </div>
      </motion.div>

      <nav className={`w-full h-[calc(100vh)] flex flex-col gap-y-[20px] px-[24px] py-[60px] bg-white text-heading1 text-label-400 ${(!isOpenMenu ? 'hidden' : '')}`}>
        <NavLink className='hover:opacity-60' to="/about">회사소개</NavLink>
        <NavLink className='hover:opacity-60' to="/business">사업내용</NavLink>
        <NavLink className='hover:opacity-60' to='/core'>핵심역량</NavLink>
        <NavLink className='hover:opacity-60' to='/news'>뉴스</NavLink>
        <NavLink className='hover:opacity-60' to='/contact'>문의하기</NavLink>
      </nav>
    </header>
  )
}